import React, { useState } from "react";
import "./LimitedEdition.css";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../../Features/Cart/cartSlice";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";
import StoreData from "../../../Data/StoreData";
import { FiHeart } from "react-icons/fi";
import { FaStar } from "react-icons/fa";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { FaCartPlus } from "react-icons/fa";
import toast from "react-hot-toast";
import { addToWishList, removeFromWishList } from "../../../Features/Wishlist/wishListSlice";


const isPreciousMetal = (metalType) => {
  const preciousMetals = ['Gold', 'Rose Gold', 'Platinum', 'White Gold'];
  return preciousMetals.includes(metalType);
};

const LimitedEdition = () => {
  const dispatch = useDispatch();
  const wishlistItems = useSelector((state) => state.wishlist.items);

  // Define limited edition product IDs
  const limitedEditionProducts = [9, 10, 11, 12, 13, 40]; // You can change these IDs as needed

  // Function to get limited edition products
  const getLimitedEditionProducts = () => {
    return StoreData.filter(product => limitedEditionProducts.includes(product.productID));
  };

  const isInWishlist = (productID) => {
    return wishlistItems.some(item => item.productID === productID);
  };

  const handleWishlistClick = (product) => {
    if (isInWishlist(product.productID)) {
      dispatch(removeFromWishList(product));
      toast.success('Removed from wishlist', {
        duration: 2000,
        style: {
          backgroundColor: "#07bc0c",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#07bc0c",
        },
      });
    } else {
      dispatch(addToWishList(product));
      toast.success('Added to wishlist', {
        duration: 2000,
        style: {
          backgroundColor: "#07bc0c",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#07bc0c",
        },
      });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const cartItems = useSelector((state) => state.cart.items);

  const handleAddToCart = (product) => {
    // Check if the product is made of precious metal
    if (isPreciousMetal(product.metalType)) {
      // For mobile cart icon clicks, show warning
      toast.error("Please contact us for current pricing on precious metal items", {
        duration: 3000,
        style: {
          backgroundColor: "#ff4b4b",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#ff4b4b",
        },
      });
      return;
    }

    // Original cart logic for non-precious metals
    const productInCart = cartItems.find(
      (item) => item.productID === product.productID
    );

    if (productInCart && productInCart.quantity >= 20) {
      toast.error("Product limit reached", {
        duration: 2000,
        style: {
          backgroundColor: "#ff4b4b",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#ff4b4b",
        },
      });
    } else {
      dispatch(addToCart(product));
      toast.success(`Added to cart!`, {
        duration: 2000,
        style: {
          backgroundColor: "#07bc0c",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#07bc0c",
        },
      });
    }
  };

  return (
    <>
      <div className="limitedProductSection">
        <h2>
          Limited <span>Edition</span>
        </h2>
        <div className="limitedProductSlider">
          <div className="swiper-button image-swiper-button-next">
            <IoIosArrowForward />
          </div>
          <div className="swiper-button image-swiper-button-prev">
            <IoIosArrowBack />
          </div>
          <Swiper
            slidesPerView={4}
            slidesPerGroup={4}
            spaceBetween={30}
            loop={true}
            navigation={{
              nextEl: ".image-swiper-button-next",
              prevEl: ".image-swiper-button-prev",
            }}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            modules={[Navigation, Autoplay]}
            breakpoints={{
              320: {
                slidesPerView: 2,
                slidesPerGroup: 1,
                spaceBetween: 14,
              },
              768: {
                slidesPerView: 3,
                slidesPerGroup: 1,
                spaceBetween: 24,
              },
              1024: {
                slidesPerView: 4,
                slidesPerGroup: 1,
                spaceBetween: 30,
              },
            }}
          >
            {getLimitedEditionProducts().map((product) => (
              <SwiperSlide key={product.productID}>
                <div className="lpContainer">
                  <div className="lpImageContainer">
                    <Link to={`/product/${product.productID}`} onClick={scrollToTop}>
                      <img
                        src={product.frontImg}
                        alt={product.productName}
                        className="lpImage"
                      />
                    </Link>
                    {isPreciousMetal(product.metalType) ? (
                        <Link 
                        to="/contact" className="LinkBlack">
                          <h4>
                            Contact for Price
                          </h4>
                        </Link>  
                        ) : (
                          <h4 onClick={() => handleAddToCart(product)}>
                            Add to Cart
                          </h4>
                        )}
                      </div>
                      <div
                        className="sdProductImagesCart"
                        onClick={() => handleAddToCart(product)}
                      >
                        <FaCartPlus />
                      </div>
                  <div className="limitedProductInfo">
                    <div className="lpCategoryWishlist">
                      <p>{product.category}</p>
                      <FiHeart
                         onClick={() => handleWishlistClick(product)}
                         style={{
                           color: isInWishlist(product.productID) ? "red" : "#767676",
                           cursor: "pointer",
                         }}
                      />
                    </div>
                    <div className="productNameInfo">
                      <Link to={`/product/${product.productID}`} onClick={scrollToTop}>
                        <h5>{product.productName}</h5>
                      </Link>
                      <div className="flex items-center">
                      {isPreciousMetal(product.metalType) ? (
                          <span style={{ color: "#767676", fontWeight: "500" }}>
                            Price on inquiry
                          </span>
                        ) : (
                          <>
                            {product.isOnSale ? (
                              <>
                                <span style={{ color: "#a52a2a", fontWeight: "500" }}>
                                  ${product.productPrice}
                                </span>
                                &nbsp;
                                <span
                                  style={{
                                    color: "#767676",
                                    textDecoration: "line-through",
                                    textDecorationThickness: "1px"
                                  }}
                                >
                                  ${product.originalPrice}
                                </span>
                              </>
                            ) : (
                              <span style={{ color: "#767676" }}>
                                ${product.productPrice}
                              </span>
                            )}
                          </>
                        )}
                      </div>
                      <div className="productRatingReviews">
                        <div className="productRatingStar">
                          {[...Array(5)].map((_, index) => (
                            <FaStar
                              key={index}
                              color={index < product.stars ? "#FEC78A" : "#C4C4C4"}
                              size={10}
                            />
                          ))}
                        </div>
                        <span>{product.productReviews}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </>
  );
};

export default LimitedEdition;
